import { useRouter } from 'next/router';
import { useCallback } from 'react';
import { Image } from '@components/common/Image';
import { UiKitButton } from '@components/common/ui-kit-button';
import { Container } from '@features/Unsubscribe/components/Container';
import { Title } from '@features/Unsubscribe/components/Title';
import { useUnsubscribeAnalytics } from '@features/Unsubscribe/hooks/use-unsubscribe-analytics';
import { closeWebView } from '@features/Unsubscribe/utils/close-web-view';
import styles from './PremiumActivated.module.scss';
export const PremiumActivated = () => {
  const {
    query
  } = useRouter();
  const {
    origin
  } = query;
  const {
    defaultEventOptions,
    trackUnsubscribeEvent
  } = useUnsubscribeAnalytics();
  const handleDone = useCallback(() => {
    trackUnsubscribeEvent('cancel_premium_activated_done_tapped');
    closeWebView();
  }, [trackUnsubscribeEvent]);
  return <Container className={styles.container} eventOnMounted="cancel_premium_activated_opened" eventOptions={defaultEventOptions} data-sentry-element="Container" data-sentry-component="PremiumActivated" data-sentry-source-file="index.tsx">
      <Image className={styles.image} src="special-3-month.webp" alt="gift-premium" width={327} height={210} data-sentry-element="Image" data-sentry-source-file="index.tsx" />
      <h3 className={styles.card}>months of Premium for free</h3>

      <Title className={styles.title} data-sentry-element="Title" data-sentry-source-file="index.tsx">Free Premium activated</Title>
      <p className={styles.subtitle}>
        We&apos;ve canceled your previous subscription and activated a new one{' '}
        <br /> <b>You won’t be charged for 90 days</b>
      </p>

      {origin === 'app' && <UiKitButton fullWidth onClick={handleDone} className={styles.button}>
          Great!
        </UiKitButton>}
    </Container>;
};